import { createFeatureSelector } from '@ngrx/store';
import { NotificationFeatureState } from './state';

export const notificationsFeatureKey = 'notificationsFeature';

export const selectFeatureState =
  createFeatureSelector<NotificationFeatureState>(notificationsFeatureKey);
